import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllZonesResponseModel, PlantIdRequest, ZoneDropDownDto, ZoneDropDownResponseModel, ZoneResponseModel,AllRacksResponseModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository ,getManager, Not} from 'typeorm';
import { PlantRequest } from './dto/plant.request';
import { RackByIdDto } from './dto/rack-id-request-dto';
import { ZoneAdapter } from './dto/zone.adapter';
import { ZoneMasterDTO } from './dto/zone.dto';
import { ZoneRequest } from './dto/zone.request';
import { ZoneMaster } from './zone-master.entity';
import appSettings from 'apps/services/config';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';


@Injectable()
export class ZoneMasterService {
    constructor(
      private logService:LogsService,

        @InjectRepository(ZoneMaster)
        private zoneRepository: Repository<ZoneMaster>,
        private zoneAdapter: ZoneAdapter,
      ) {}
      /**
       * create or update Zone
       * @param zoneMasterDTO 
       * @param isUpdate 
       * @param request 
       */
      async createZone(zoneMasterDTO: ZoneMasterDTO, isUpdate: boolean,request:Request): Promise<ZoneResponseModel> {
        try {
            // to check whether Zone exists with the passed  Zone  or not. if isUpdate is false, a check will be done whether a record with the passed Zone is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Zone  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
            const ZoneEntity = await this.getZoneDetailsWithoutRelations(zoneMasterDTO.zoneCode);
            if (ZoneEntity) {
                throw new ZoneResponseModel(false,11104, 'Zone already exists');         
            }         
            }
            else{
                const ZoneEntity = await this.getZoneDetailsWithoutRelations(zoneMasterDTO.zoneCode);
                if(ZoneEntity){
                    if(ZoneEntity.zoneId!=zoneMasterDTO.zoneId) {
                        throw new ZoneResponseModel(false,11104, 'Zone already exists');      
                    }
                }
              }
            console.log(zoneMasterDTO);
            
            const convertedZoneEntity: ZoneMaster = this.zoneAdapter.convertDtoToEntity(zoneMasterDTO,isUpdate);
            console.log(zoneMasterDTO);

            console.log(convertedZoneEntity);
            const savedZoneEntity: ZoneMaster = await this.zoneRepository.save(
            convertedZoneEntity
            );
            console.log(savedZoneEntity);

            const savedZoneDto: ZoneMasterDTO = this.zoneAdapter.convertEntityToDto(savedZoneEntity);
            if (savedZoneDto) {
            // generating resposnse
            const response = new ZoneResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Zone Updated Successfully': 'Zone Created Successfully',savedZoneDto);
            const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'ZoneMaster', savedZoneDto.zoneId, true, '',savedZoneDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new ZoneResponseModel(false,11106,'Zone saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get Zone details
     * @param zoneCode 
     */
    // @LogActions({isAsync: true})
    async getZoneDetailsWithoutRelations(zoneCode: string): Promise<ZoneMaster> {
        // tslint:disable-next-line: typedef
        const ZoneResponse = await this.zoneRepository.findOne({
        where: {zoneCode: Raw(alias => `zone_code = '${zoneCode}'`)},
        });
        console.log(ZoneResponse);
        if (ZoneResponse) {
        return ZoneResponse;
        } else {
        return null;
        }
    }
    /**
     * get All Zones
     */
    // async getAllZones(): Promise<AllZonesResponseModel> {
    //     // const page: number = 1;
    //     try {
    //       const zoneMasterDTO: ZoneMasterDTO[] = [];
    //       //retrieves all companies
    //       const zonesEntities: ZoneMaster[] = await this.zoneRepository.find({order :{zoneId:'ASC'}});
    //       if (zonesEntities) {
    //         // converts the data fetched from the database which of type companies array to type StateDto array.
    //         zonesEntities.forEach(zoneEntity => {
    //           const convertedzonesDto: ZoneMasterDTO = this.zoneAdapter.convertEntityToDto(
    //             zoneEntity
    //           );
    //           zoneMasterDTO.push(convertedzonesDto);
    //         });
    //         const response = new AllZonesResponseModel(true,11108,"Zones retrieved successfully",zoneMasterDTO);
    //         return response;
    //       } else {
    //         throw new ZoneResponseModel(false,99998, 'Data not found');
    //       }
    //     } catch (err) {
    //       return err;
    //     }
    //   }
      async getPlantZones(plantIdRequest:PlantRequest): Promise<AllZonesResponseModel> {
        // const page: number = 1;
        console.log('getall zones service')
        console.log(plantIdRequest);
        
        try {
          const zoneMasterDTO: ZoneMasterDTO[] = [];
          //retrieves all companies
          let zonesEntities: ZoneMaster[];
          if(plantIdRequest.plantId === 5){
            zonesEntities = await this.zoneRepository.find({where: { isActive:true },order :{zoneId:'ASC'}});
          }
          else{
            zonesEntities = await this.zoneRepository.find({where: { plantId: plantIdRequest.plantId,isActive:true },order :{zoneId:'ASC'}});
          }
          if (zonesEntities) {
              console.log(zonesEntities);
            // converts the data fetched from the database which of type companies array to type StateDto array.
            zonesEntities.forEach(zoneEntity => {
              const convertedzonesDto: ZoneMasterDTO = this.zoneAdapter.convertEntityToDto(
                zoneEntity
              );
              zoneMasterDTO.push(convertedzonesDto);
            });
            const response = new AllZonesResponseModel(true,11108,"Zones retrieved successfully",zoneMasterDTO);
            return response;
          } else {
            throw new ZoneResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          return err;
        }
      }
      async getAllActiveZones(): Promise<AllZonesResponseModel> {
        // const page: number = 1;
        try {
            const zoneMasterDTO: ZoneMasterDTO[] = [];
            //retrieves all companies
            const zonesEntities: ZoneMaster[] = await this.zoneRepository.find({ order: { zoneName: 'ASC' },
           });
         console.log(zonesEntities)
            if (zonesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                zonesEntities.forEach(zoneEntity => {
                    const convertedzonesDto: ZoneMasterDTO = this.zoneAdapter.convertEntityToDto(
                      zoneEntity
                    );
                    zoneMasterDTO.push(convertedzonesDto);
                });
                const response = new AllZonesResponseModel(true, 11108, "Zones retrieved successfully", zoneMasterDTO);
                return response;
            } else {
                throw new ZoneResponseModel(false,99998, 'Data not found'); zoneMasterDTO
            }
        } catch (err) {
            throw err;
        }
    }
      /**
       * Activate or Deactivate Zone
       * @param zoneReq 
       */
      async activateOrDeactivateZone(zoneReq: ZoneRequest): Promise<ZoneResponseModel> {
        try {
            const zoneExists = await this.getZoneById(zoneReq.zoneId);
            if (zoneExists) {
                if (zoneReq.versionFlag !== zoneExists.versionFlag) {
                    throw new ZoneResponseModel(false,10113, 'Someone updated the current Zone information.Refresh and try again');
                } else {
                    
                        const zoneStatus =  await this.zoneRepository.update(
                            { zoneId: zoneReq.zoneId },
                            { isActive: zoneReq.isActive,updatedUser: zoneReq.updatedUser });
                       
                        if (zoneExists.isActive) {
                            if (zoneStatus.affected) {
                                const zoneResponse: ZoneResponseModel = new ZoneResponseModel(true, 10115, 'Zone is de-activated successfully');
                                return zoneResponse;
                            } else {
                                throw new ZoneResponseModel(false,10111, 'Zone is already deactivated');
                            }
                        } else {
                            if (zoneStatus.affected) {
                                const zoneResponse: ZoneResponseModel = new ZoneResponseModel(true, 10114, 'Zone is activated successfully');
                                return zoneResponse;
                            } else {
                                throw new ZoneResponseModel(false,10112, 'Zone is already activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ZoneResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    /**
     * get Zone while passing id
     * @param zoneId 
     */
    async getZoneById(zoneId: number): Promise<ZoneMaster> {
          const Response = await this.zoneRepository.findOne({
          where: {zoneId: zoneId},
          });
          if (Response) {
          return Response;
          } else {
          return null;
          }
      }

      async getAllZoneDropDown(): Promise<ZoneDropDownResponseModel> {
        try {
            const zoneDTO: ZoneDropDownDto[] = [];
            const zoneEntities: ZoneMaster[] = await this.zoneRepository.find({ select: ['zoneId', 'zoneName'], where: { isActive: true }, order: {zoneName:"ASC"}})


            if (zoneEntities && zoneEntities.length > 0) {
                zoneEntities.forEach(zoneEntity => {
                    zoneDTO.push(new ZoneDropDownDto(zoneEntity.zoneId, zoneEntity.zoneName));
                });
                const response = new ZoneDropDownResponseModel(true, 11108, "zone retrieved successfully", zoneDTO);
                return response;
            } else {
                throw new ZoneResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getAllZones(): Promise<CommonResponse> {
        try{
            const manager = getManager();
            const query = `SELECT z.zone_id as zoneId, z.zone_name as zoneName,uc.unit_name as plantName,z.zone_code as zoneCode,z.is_active as isActive,z.created_user as createdUser,z.updated_user as updatedUser,z.version_flag as versionFlag FROM ` + appSettings.masters_db  + `.zone_master z
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = z.plant_id`
            const data = await manager.query(query)
            if(data.length > 0){
            const response = new CommonResponse(true, 11208, "Racks retrieved successfully", data);
            const newLogDto = new LogsDto(1,'view', 'ZoneMaster', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            }else{
                throw new ZoneResponseModel(false,99998,'No Record Found');
            }   
        }catch(err){
            throw err
        }

    }

   
    async getzoneForRackId(): Promise<ZoneDropDownResponseModel> {
        try {
            const zones: ZoneDropDownDto[] = [];
            const zoneEntities: ZoneMaster[] = await this.zoneRepository.find({ select: ['zoneId', 'zoneName'], where: { isActive: true}})


            if (zoneEntities && zoneEntities.length > 0) {
                zoneEntities.forEach(zoneEntities => {
                    zones.push(new ZoneDropDownDto(zoneEntities.zoneId, zoneEntities.zoneName));
                });
                const response = new ZoneDropDownResponseModel(true, 11108, "zone retrieved successfully",zones);
                return response;
            } else {
                throw new ZoneResponseModel(false,99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getPlantZonesExceptFromZone(plantIdRequest:PlantRequest): Promise<AllZonesResponseModel> {
        try {
          const zoneMasterDTO: ZoneMasterDTO[] = [];
          //retrieves all companies
          let zonesEntities: ZoneMaster[];
          if(plantIdRequest.plantId === 5){
            zonesEntities = await this.zoneRepository.find({where: { isActive:true,zoneId : Not(plantIdRequest.zoneId) },order :{zoneId:'ASC'}});
          }
          else{
            zonesEntities = await this.zoneRepository.find({where:{isActive:true,plantId: plantIdRequest.plantId,zoneId : Not(plantIdRequest.zoneId)}, order :{zoneId:'ASC'}});
          }
          if (zonesEntities) {
              console.log(zonesEntities);
            // converts the data fetched from the database which of type companies array to type StateDto array.
            zonesEntities.forEach(zoneEntity => {
                if(plantIdRequest.zoneId != zoneEntity.zoneId){
                    const convertedzonesDto: ZoneMasterDTO = this.zoneAdapter.convertEntityToDto(
                        zoneEntity
                      );
                      zoneMasterDTO.push(convertedzonesDto);
                }
            });
            const response = new AllZonesResponseModel(true,11108,"Zones retrieved successfully",zoneMasterDTO);
            return response;
          } else {
            throw new ZoneResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          return err;
        }
      }

}
